import './styles/tokens.css';
import './styles/base.css';
import './styles/layout.css';
import './styles/doc.css';
import { boot } from './app';

boot();
